import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
} from '@material-ui/core'
import { useField } from 'formik'
import React from 'react'

export const FormikSelect = ({
  fullWidth,
  label,
  margin,
  options,
  shrink,
  variant,
  ...props
}) => {
  const [field, meta] = useField(props)
  const { touched, error } = meta
  const hasError = Boolean(touched && error)

  const renderSelectedOptions = (options, selected) => {
    return options
      .filter(o => selected.includes(o.value))
      .map(r => r.label)
      .join(', ')
  }

  return (
    <FormControl
      error={hasError}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
    >
      <InputLabel shrink={shrink}>{label}</InputLabel>
      {props.multiple ? (
        <Select
          {...field}
          {...props}
          renderValue={() => renderSelectedOptions(options, field.value)}
        >
          {options.map((option, idx) => (
            <MenuItem key={idx} value={option.value}>
              <Checkbox checked={field.value.includes(option.value)} />
              {option.label}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select {...field} {...props}>
          {options.map((option, idx) => (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      )}
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

FormikSelect.defaultProps = {
  variant: 'filled',
}

export default FormikSelect
